class WishDay{

    constructor(isPublicHoliday, nameOfWeekday){
        this.intervalsOfThisDay = new Array(96);
        this.nameOfWeekday = nameOfWeekday;
        this.isPublicHoliday = isPublicHoliday;
        this.splittingShiftFound = false;
    }

    setInterval(numberOfIntervall, valueOfIntervall){
        this.intervalsOfThisDay[numberOfIntervall] = valueOfIntervall;
    }
    getInterval(numberOfIntervall){
        return this.intervalsOfThisDay[numberOfIntervall];
    }
    getAllIntervalsOfThisDay(numberOfIntervall){
        let stringAllIntervallsOfThisDay = "";
        for(i=0; i<= this.intervalsOfThisDay; i++){
            stringAllIntervallsOfThisDay += intervalsOfThisDay[i];
        }
    }
    getNameOfWeekday(){
        return this.nameOfWeekday;
    }
    getPublicHoliday(){
        return this.isPublicHoliday;
    }


}